module.exports = __webpack_public_path__ + "img/selected5-min.10ba7827.png";